import { brandStats, testimonials } from "@/mocks/chiGuaData";

const statText = [
  "text-primary-600",
  "text-accent-600",
  "text-secondary-600",
  "text-primary-600",
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5 lg:gap-10">
          {/* 品牌介绍 */}
          <div className="lg:col-span-3">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-500/15 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-sparkling-2-fill" aria-hidden="true"></i> 关于我们
            </span>
            <h2 className="mt-3 font-heading text-2xl leading-tight text-foreground-950 md:text-3xl">
              关于「吃瓜网上」：让每一次冲浪都有收获
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              吃瓜网上是一个专注内容发现与轻松阅读的平台。我们相信，好的内容不该被海量信息淹没，也不该被算法困在茧房里。于是我们把热门事件、新鲜事和有趣话题整理成一份份清晰的浏览推荐，让大家用更少的时间，找到更多自己真正感兴趣的精彩。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              我们的内容团队坚持每日精选、实时更新，并通过「热门瓜榜」捕捉正在升温的讨论。同时，我们也倡导理性吃瓜：对争议话题多方对照、核实来源，不信谣、不传谣。希望你在这里，既能追得上热点，也保持清醒的判断。
            </p>

            <div className="mt-7 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {brandStats.map((s, i) => (
                <div
                  key={s.label}
                  className="rounded-lg border border-background-200 bg-background-100 p-4 text-center"
                >
                  <p className={`font-heading text-xl md:text-2xl ${statText[i % statText.length]}`}>
                    {s.value}
                  </p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 用户口碑 */}
          <div className="lg:col-span-2">
            <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6">
              <h3 className="font-heading text-xl text-foreground-950">他们怎么说</h3>
              <p className="mt-1 text-xs text-foreground-500">来自不同吃瓜小伙伴的真实反馈</p>
              <div className="mt-5 flex flex-col gap-4">
                {testimonials.map((t) => (
                  <figure key={t.name} className="rounded-lg bg-background-50 p-4">
                    <blockquote className="text-sm leading-relaxed text-foreground-700">
                      “{t.quote}”
                    </blockquote>
                    <figcaption className="mt-3 flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">
                        {t.initial}
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                        <p className="text-xs text-foreground-500">{t.role}</p>
                      </div>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}